import component from './PhPoliceCar.vue_vue&type=script&lang.js';
export { default } from './PhPoliceCar.vue_vue&type=script&lang.js';
import { render } from './PhPoliceCar.vue_vue&type=template&id=5cf79c26&lang.js';

component.render = render;
